/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { styled } from '@mui/material/styles';
import { Typography, Stack, Paper, Button, Box } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import Container from '@mui/material/Container';
import Skeleton from '@mui/material/Skeleton';
import { clearAccessToken } from 'slice/user';
import { resetInitialState } from 'slice/form';
import { cancelUpdateMode, cancelReadMode } from 'slice/step';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

import FrameImg from '@/assets/images/Frame.png';
import GroupImg from '@/assets/images/Group.png';

const Title = styled(Typography)({
  color: '#375a7f',
  lineHeight: '46px',
  fontWeight: 600,
  textAlign: 'center',
});
const MyPaper = styled(Paper)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    width: '344px',
    height: '292px',
  },
  [theme.breakpoints.down('sm')]: {
    width: '280px',
    height: '280px',
  },
  display: 'block',
  borderRadius: '10px',
}));
const MyTypography = styled(Typography)({
  fontSize: '24px',
  color: 'black',
  width: '100%',
  textAlign: 'center',
  lineHeight: '35px',
  fontWeight: 500,
  textTransform: 'capitalize',
  padding: '0 25px',
});

const StackStyle = styled(Stack)({
  justifyContent: 'center',
  alignItems: 'center',
});

const MyButton = styled(Button)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
});

function MainContent(props) {
  const { handleClick, handleClickEdit } = props;
  const { info } = useSelector((state) => state.main);
  const dispatch = useDispatch();

  const isMd = useMediaQuery('(min-width:900px)');
  const isPhone = useMediaQuery('(max-width:600px)');
  const { t } = useTranslation('main');

  useEffect(() => {
    dispatch(clearAccessToken());
    dispatch(cancelUpdateMode());
    dispatch(cancelReadMode());
    dispatch(resetInitialState());
  }, []);

  return (
    <Box>
      {info.reg_status || info?.edit_status ? (
        <div>
          {isPhone && (
            <Typography
              variant="h5"
              component="div"
              sx={{
                textAlign: 'center',
                fontWeight: 900,
                fontSize: { xs: 24, md: 32 },
              }}
            >
              {/* 保良局教育事務部屬下幼稚園 */}
              {info.name ? (
                info.name
              ) : (
                <Skeleton variant="rounded" width={300} height={45} />
              )}
            </Typography>
          )}

          <Title
            component="div"
            variant="h5"
            sx={{
              fontSize: { xs: 24, md: 32 },
              margin: { xs: '20px 0', md: '40px 0 ' },
            }}
          >
            {t('welcome_online_apply_system')}
          </Title>
          <StackStyle
            direction={isMd ? 'row' : 'column'}
            spacing={7}
            sx={{ marginBottom: '20px' }}
          >
            {info?.reg_status === 'Y' && (
              <MyPaper>
                <MyButton
                  onClick={handleClick}
                  sx={{
                    width: '100%',
                    height: '100%',
                    padding: '30px 0',
                    // justifyContent: 'space-around',
                  }}
                >
                  <img
                    src={FrameImg}
                    style={{ margin: 'auto' }}
                    alt="FrameImg"
                  />
                  {info?.btn_reg === null ? (
                    <MyTypography variant="subtitle2">
                      {t('online_appliy_form')}
                    </MyTypography>
                  ) : (
                    <MyTypography
                      component="div"
                      className="ql-editor"
                      dangerouslySetInnerHTML={{ __html: info?.btn_reg }}
                      variant="subtitle2"
                    />
                  )}
                </MyButton>
              </MyPaper>
            )}
            {info?.edit_status === 'Y' && (
              <MyPaper>
                <MyButton
                  onClick={handleClickEdit}
                  sx={{
                    width: '100%',
                    height: '100%',
                    padding: '30px 0',
                    // justifyContent: 'space-between',
                  }}
                >
                  <img
                    src={GroupImg}
                    style={{ margin: 'auto' }}
                    alt="GroupImg"
                  />
                  {info?.btn_edit === null ? (
                    <MyTypography variant="subtitle2">
                      {t('change_print_data')}
                    </MyTypography>
                  ) : (
                    <MyTypography
                      component="div"
                      className="ql-editor"
                      dangerouslySetInnerHTML={{ __html: info?.btn_edit }}
                      style={{ textTransform: 'none' }}
                      variant="subtitle2"
                    />
                  )}
                </MyButton>
              </MyPaper>
            )}

            {info?.reg_status === 'N' && info?.edit_status === 'N' && (
              <Typography sx={{ fontSize: '32px' }}>
                {t('no_admission_form')}
              </Typography>
            )}
          </StackStyle>
          {info?.edit_status === 'Y' && (
            <Container maxWidth="specificallyMd">
              <Box sx={{ marginBottom: { md: '50px', xs: '20px' } }}>
                <Typography variant="subtitle2">
                  <ReactMarkdown
                    // eslint-disable-next-line react/no-children-prop
                    children={info?.home}
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[rehypeRaw]}
                    linkTarget="_blank"
                    // className={markdownStyle.markdownStyle}
                  />
                </Typography>
              </Box>
            </Container>
          )}
        </div>
      ) : (
        <Box sx={{ pt: 10 }}>
          <Box sx={{ display: 'flex', justifyContent: 'start' }}>
            <Skeleton animation="wave" height={40} width="100%" />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'start', mt: 4, mb: 5 }}>
            <Skeleton animation="wave" height={40} width="80%" />
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default MainContent;
